export default __webpack_public_path__ + "static/media/paymentMethod.21a97263.png";